<template>
  <ul>
    <component
      :is="resolveNavItemComponent(item)"
      v-for="item in items"
      :key="item.route || item.title"
      :item="item"
    />
  </ul>
</template>

<script>
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@core/layouts/utils'
import { provide, ref } from '@vue/composition-api'
import VerticalNavMenuHeader from '../vertical-nav-menu-header'
import VerticalNavMenuLink from '../vertical-nav-menu-link/VerticalNavMenuLink.vue'
import VerticalNavMenuGroup from '../vertical-nav-menu-group/VerticalNavMenuGroup.vue'

export default {
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    VerticalNavMenuGroup,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  setup() {
    provide('openGroups', ref([]))

    return {
      resolveNavItemComponent,
    }
  },
}
</script>

<style>
[dir=ltr] .main-menu.menu-light .navigation > li.active > a {
  background: linear-gradient(118deg, #d92c2f, rgba(217, 44, 47, 1));
  /* border:1px solid #fff; */
  /* background: transparent !important; */
}

[dir] .admin-menu .navigation > li.open:not(.menu-item-closing) > a,
[dir] .admin-menu .navigation > li.sidebar-group-active > a {
  /* border:1px solid #fff; */
  /* background: transparent; */
  background: linear-gradient(118deg, #d92c2f, rgba(217, 44, 47, 1)) !important;
  color: #fff;
}
</style>
